import * as reactiveUtils from "@arcgis/core/core/reactiveUtils";
import { LOG_MODULES } from "@config/config";
import { log } from '@libs/utils/helper.js';

/**
 * Sets up a reactiveUtils watcher to sync table filterGeometry with map extent.
 * Only active when isMapExtentFilterEnabledRef.current is true.
 */
const logFtTbl = LOG_MODULES.FEATURETABLBE;
const isNeedLog = false;

// Destructured object parameter to match bindAllEvents pattern
export function bindExtentWatcher({ mapView, table,isMapExtentFilterEnabledRef }) { //
  if (isNeedLog) log(logFtTbl, "[bindExtentWatcher] binding extent watcher");

  const watcher = reactiveUtils.watch(
    () => ({ stationary: mapView.stationary, extent: mapView.extent }),
    ({ stationary, extent }) => {
      // Apply the spatial filter only if the map is still AND the user enabled the toggle
      if (stationary && extent && isMapExtentFilterEnabledRef.current) { //
        if (isNeedLog) log(logFtTbl, "[extentWatcher] applying filterGeometry");
        table.filterGeometry = extent;
      }
    },
    { initial: true }
  );

  return () => {
    if (isNeedLog) log(logFtTbl, "[bindExtentWatcher] cleanup");
    watcher.remove();
  };
}